<template>
  <PageLayout
    class="faq-list"
    title="FAQ"
    :showLangChoose="false"
    :clickLeft="back"
  >
    <div class="faq-list-wrap">
      <faq-notice-bar :source="locationType.faqListPage"></faq-notice-bar>
    </div>
    <div class="faq-list-content">
      <van-tabs
        v-model="firstClassActive"
        class="faq-list-type-1"
        :swipe-threshold="4"
        :ellipsis="false"
        @click="handleFirstClassClick"
        ref="firstClassRef"
      >
        <van-tab v-for="item in faqClassList" :key="item.id" :name="item.id">
          <template #title>
            <div class="faq-list-title">
              <div class="faq-list-title-ico-wrap">
                <img
                  :src="item.icon"
                  class="faq-list-title-ico iconfont icon-bo"
                  v-if="item.icon"
                />
                <em class="icon iconfont icon-box" v-else></em>
              </div>
              <p class="faq-list-title-text">
                {{ item.text }}
              </p>
            </div>
          </template>
          <van-tabs
            class="faq-list-type-2"
            v-model="secondTypeActive[item.id]"
            @click="handleSecondClassClick"
            :ellipsis="false"
            v-if="showTabs && item.id == firstClassActive"
          >
            <van-tab
              v-for="sub in item.sub"
              :key="sub.id"
              :title="sub.text"
              :name="sub.id"
            >
              <van-list
                v-if="
                  secondClassList[sub.id] && secondClassList[sub.id].length > 0
                "
              >
                <van-cell
                  class="faq-list-type-2-item"
                  v-for="article in secondClassList[sub.id]"
                  :key="article.id"
                  :title="article.TITLE"
                  @click="goToDetail(article.ID)"
                />
              </van-list>
              <p v-else class="faq-list-tips">
                {{ loading ? 'Loading' : languages.smartOrderComing }}
              </p>
            </van-tab>
          </van-tabs>
        </van-tab>
      </van-tabs>
    </div>
  </PageLayout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageLayout from '@components/officialSupport/common/PageLayout.vue';
import FaqNoticeBar from '@components/officialSupport/FaqNoticeBar.vue';
import {
  locationType,
  clickButton
} from '@plugins/biPoint/_configOfficialSupport';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import globalConfig from '@utiles/globalConfig';
export default {
  name: 'WorkFaqList',
  mixins: [pointStayTime],
  data() {
    return {
      firstClassActive: 0,
      secondTypeActive: {},
      secondClassList: {},
      nowListLang: '',
      loading: false,
      locationType,
      showTabs: false
    };
  },
  computed: {
    ...mapState({
      curLang: state => state.curLang,
      languages: state => state.languages,
      letter: state => state.languages?.mywork,
      isLogin: state => state.isLogin,
      faqSiteName: state => state.faqSiteName,
      faqClassList: state => state.faqClassList
    }),
    firstClassId() {
      return this.$route.query.firstClassId;
    }
  },
  async created() {
    this.initSecondClassActive();
    this.nowListLang = this.curLang;
  },
  deactivated() {
    this.showTabs = false;
  },
  activated() {
    this.showTabs = true;
    this.$refs?.firstClassRef?.tabs?.resize();
  },
  methods: {
    ...mapActions(['getFaqClassArticleList']),
    back() {
      if (globalConfig.isTiktokMiniProgram()) {
        this.$router.push('/workhome');
      } else {
        this.$router.go(-1);
      }
    },
    goToDetail(faqId) {
      clickButton({
        btnName: 'goFaqDetail',
        locationKey: locationType.faqListPage,
        otherParams: {
          faqId
        }
      });
      this.$router.push({
        name: 'workfaqdetail',
        query: {
          faqId
        }
      });
    },
    initSecondClassActive() {
      this.faqClassList.forEach(item => {
        this.$set(this.secondTypeActive, item.id, 0);
      });
    },
    async loadSecondClassList(id) {
      try {
        if (this.secondClassList[id]) return;
        this.loading = true;
        const data = await this.getFaqClassArticleList({
          classId: id
        });

        this.$set(this.secondClassList, id, data);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleFirstClassClick(name) {
      clickButton({
        btnName: 'clickFaqFirstClass',
        locationKey: locationType.faqListPage,
        otherParams: {
          faqClassId: name
        }
      });
    },
    handleSecondClassClick(name) {
      clickButton({
        btnName: 'clickFaqSecondClass',
        locationKey: locationType.faqListPage,
        otherParams: {
          faqClassId: name
        }
      });
    }
  },
  watch: {
    firstClassId: {
      handler(val) {
        this.firstClassActive = val;
      },
      immediate: true
    },
    secondTypeActive: {
      handler(val) {
        Object.keys(val).forEach(key => {
          if (val[key] == 0 || this.secondClassList[val[key]]) return;
          this.loadSecondClassList(val[key]);
        });
      },
      immediate: true,
      deep: true
    },
    curLang(val) {
      if (this.nowListLang != val) {
        this.initSecondClassActive();
        this.secondClassList = {};
        this.nowListLang = val;
        Object.keys(this.secondTypeActive).forEach(key => {
          if (
            this.secondTypeActive[key] == 0 ||
            this.secondClassList[this.secondTypeActive[key]]
          )
            return;
          this.loadSecondClassList(this.secondTypeActive[key]);
        });
      }
    }
  },
  components: {
    PageLayout,
    FaqNoticeBar
  }
};
</script>
<style lang="scss" scoped>
.faq-list {
  &-wrap {
    padding: 0 10px;
    box-sizing: border-box;
  }
  &-content {
    background: var(--block-bg-light-color);
  }

  &-type-1 {
    height: 101px;
    padding-top: 10px;
    ::v-deep .van-tabs__nav {
      min-height: 80px;
    }
    ::v-deep .van-tab {
      color: var(--text-color);
      // min-height: 80px;
    }
    ::v-deep .van-tabs__wrap {
      height: 101px;
      overflow: visible;
    }
    ::v-deep .van-tab--active {
      color: var(--main-color);
      font-weight: normal;
    }
    ::v-deep .van-tabs__line {
      display: none;
    }
    ::v-deep .van-tab__text {
      font-size: 16px;
    }
  }
  &-type-2 {
    height: 46px;
    margin-top: 10px;
    ::v-deep .van-tab {
      min-height: unset;
    }
    ::v-deep .van-tabs__wrap {
      height: 46px;
    }
    ::v-deep .van-tabs__line {
      display: block;
      background-color: var(--main-color);
    }
    ::v-deep .van-tabs__content {
      background: var(--block-bg-light-color);
      min-height: calc(100vh - 311px);
    }
    ::v-deep .van-tabs__nav {
      min-height: unset;
    }
    ::v-deep .van-cell__title span {
      word-break: break-all;
    }
    &-item {
      font-size: 16px;
      padding: 30px 10px;
      &::after {
        border: 1px dashed #d8d8d8;
      }
    }
  }
  &-title {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    height: 90px;
    &-ico {
      display: block;
      width: 40px;
      height: 40px;
      filter: grayscale(100%) brightness(50%);
    }
    &-text {
      font-size: 16px;
      text-align: center;
    }
    &-ico-wrap {
      flex-shrink: 0;
      display: block;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 64px;
      border-radius: 50%;
      box-sizing: border-box;
      margin-bottom: 10px;
      background: #f2f4f9;
    }
  }
  &-tips {
    font-size: 16px;
    text-align: center;
    color: var(--text-color);
    padding-top: 20px;
  }
}
.icon {
  display: block;
  font-size: 40px;
  color: var(--main-color);
  filter: grayscale(100%) brightness(50%);
}
.van-tab--active {
  .icon {
    filter: none;
  }
  .faq-list-title-ico {
    filter: none;
  }
  .faq-list-title-ico-wrap {
    background: var(--menu-item-top-bgColor);
  }
}
</style>
